// extracted by mini-css-extract-plugin
export default {"signUpContainer":"SignUp_signUpContainer__7BCx8","heading":"SignUp_heading__G3s4A","signupForm":"SignUp_signupForm__ZSISn","signupBtn":"SignUp_signupBtn__hRoBc"};